import type { VoidFunctionComponent } from 'react';

import NavigationButton from '../../../generic/Button/NavigationButton';
import { icons } from '../../../generic/Icon/icons';

import styles from './AddProjectsCTA.module.less';

const AddReleaseGroupCTA: VoidFunctionComponent = () => {
  return (
    <div className={styles.addProjectsCTA}>
      <div className={styles.message}>
        There aren&apos;t any release groups here! Get started by creating one with the button below:
      </div>
      <NavigationButton to="/projects/group/create" size="medium" icon={icons.plus}>
        Add Release Group
      </NavigationButton>
    </div>
  );
};

export default AddReleaseGroupCTA;
